import React from "react";
import * as Mui from "@mui/material";
import { detailCardSx } from "components/DesignSystem/RequestDetailField";
import { GlobalFieldLabel } from "components/DesignSystem/sharedUiPatterns";
import { designColors, designType } from "services/constants/designTokens";

// Building blocks for the Pay Inputs Add / Edit / View side panels.

// Panel body: light page background with padding, sections as white cards
// (same as the My Zone request form panels).
export const panelBodySx = {
  backgroundColor: designColors.pageBg,
  p: { xs: 2, sm: 3 },
};

// Label + one-line "info" helper (same as the other form panels). Helpers
// are kept to one short line so paired inputs line up without reserving a
// fixed label height (which left a gap above the input).
// `wide`: spans both grid columns — for a lone trailing field in an
// odd-count section, which otherwise leaves its row's other cell blank.
export const Field = ({ label, helper, error, wide, children }) => (
  <Mui.Box sx={{ minWidth: 0, ...(wide ? { gridColumn: "1 / -1" } : {}) }}>
    <GlobalFieldLabel helperText={helper}>{label}</GlobalFieldLabel>
    {children}
    {error ? (
      <Mui.Typography sx={{ ...designType.captionText, color: "#DC2626", mt: 0.5 }}>
        {error}
      </Mui.Typography>
    ) : null}
  </Mui.Box>
);

// One white card per form section: title, a one-line info note, then the
// fields in a 2-column grid (1 column on phones).
export const FormSection = ({ title, info, footer, children }) => (
  <Mui.Box sx={detailCardSx}>
    <Mui.Typography sx={designType.sectionHeading}>{title}</Mui.Typography>
    {info ? (
      <Mui.Typography sx={{ ...designType.helperText, mt: 0.25, mb: 2 }}>
        {info}
      </Mui.Typography>
    ) : null}
    <Mui.Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        columnGap: 2,
        rowGap: 2,
        mt: info ? 0 : 2,
      }}
    >
      {children}
    </Mui.Box>
    {footer}
  </Mui.Box>
);
